import axios from './axios';

const getStudyInfo = async (opintopolkuId) => {
	const response = await axios.get(`/talents/opintopolku/${opintopolkuId}`);
	return response.data;
};

export { getStudyInfo };
